function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 14C1 14 0 14 0 13C0 12 1 9 6 9C11 9 12 12 12 13C12 14 11 14 11 14H1ZM6 8C6.79565 8 7.55871 7.68393 8.12132 7.12132C8.68393 6.55871 9 5.79565 9 5C9 4.20435 8.68393 3.44129 8.12132 2.87868C7.55871 2.31607 6.79565 2 6 2C5.20435 2 4.44129 2.31607 3.87868 2.87868C3.31607 3.44129 3 4.20435 3 5C3 5.79565 3.31607 6.55871 3.87868 7.12132C4.44129 7.68393 5.20435 8 6 8V8ZM15.854 5.146C15.9006 5.19245 15.9375 5.24762 15.9627 5.30837C15.9879 5.36911 16.0009 5.43423 16.0009 5.5C16.0009 5.56577 15.9879 5.63089 15.9627 5.69163C15.9375 5.75238 15.9006 5.80755 15.854 5.854L12.854 8.854C12.8076 8.90056 12.7524 8.93751 12.6916 8.96271C12.6309 8.98792 12.5658 9.00089 12.5 9.00089C12.4342 9.00089 12.3691 8.98792 12.3084 8.96271C12.2476 8.93751 12.1924 8.90056 12.146 8.854L10.646 7.354C10.5521 7.26011 10.4994 7.13278 10.4994 7C10.4994 6.86722 10.5521 6.73989 10.646 6.646C10.7399 6.55211 10.8672 6.49937 11 6.49937C11.1328 6.49937 11.2601 6.55211 11.354 6.646L12.5 7.793L15.146 5.146C15.1924 5.09944 15.2476 5.06249 15.3084 5.03729C15.3691 5.01208 15.4342 4.99911 15.5 4.99911C15.5658 4.99911 15.6309 5.01208 15.6916 5.03729C15.7524 5.06249 15.8076 5.09944 15.854 5.146V5.146Z",
  fill: "#A0AEC0"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));

var SvgFollowing = function SvgFollowing(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFollowing, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/following.af76d801.svg";
export { ForwardRef as ReactComponent };